import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPen, faEraser } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad3.mp3";
import Imagen1 from "../../../images/modulo13/transformacion.png";
import Modulo13U1Act3 from "../../../DnD/modulo13U1Act3";
import GuiaDocente from "../../../components/GuiaDocente";
import { ReactSketchCanvas } from "react-sketch-canvas";
const styles = {
  height: "580px",
  background: `url(${Imagen1})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
};


const Actividad5 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[3];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[4].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[4].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[2].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[2].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  const items = [
    <div className="selectable btn btn-red shadow mx-3 my-1">territorio</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">
      entorno natural
    </div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">transformar</div>,
  ];

  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-5">
        <li>
        Coloca cada palabra o frase con su significado.
        </li>
      </ul>

      <Modulo13U1Act3 items={items} />

      <ul className="mt-5">
        <li>
          En la siguiente ilustración, encierra en un círculo todo lo que haya
          sido transformado por el ser humano.
        </li>
      </ul>

      <ReactSketchCanvas
        ref={canvasEl}
        style={styles}
        width="600"
        height="100%"
        strokeWidth={4}
        strokeColor="red"
      />
      <div className="col-12 px-5">
        <div className="d-flex mt-1 justify-content-end w-100">
          <button
            onClick={activateEraser}
            className={`btn btn-green me-1 ${
              eraseMode ? "active" : "inactive"
            }`}
          >
            Borrador <FontAwesomeIcon icon={faEraser} />
          </button>
          <button
            onClick={activatePen}
            className={`btn btn-green me-1 ${penMode ? "active" : "inactive"}`}
          >
            Lapiz <FontAwesomeIcon icon={faPen} />
          </button>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Explique que estas actividades buscan trabajar con
            palabras nuevas relacionadas con el territorio. El objetivo es que
            aprendan sus significados y amplíen su vocabulario.
          </li>
          <li>
            Lea la primera indicación: Coloca las palabras en el recuadro de la
            definición que les corresponda. Pida a un o una estudiante que lea
            en voz alta las palabras y las definiciones. Dé un tiempo para
            trabajar. Pregunte por sus respuestas y revisen
            conjuntamente la actividad. Comente que existen distintos conceptos
            acerca de la palabra territorio. En la actualidad, se resalta que el
            territorio es el espacio vivido por las personas; es decir, se
            enfatiza que es el espacio transformado por el ser humano. Comente
            que la palabra entorno se refiere a todo aquello que rodea a algo o
            alguien. Cuando se habla de entorno natural, nos referimos, por
            ejemplo, a las tierras, ríos, lagos y mares que nos rodean y que no
            han sido cambiado por las personas. Comente que la palabra
            transformar implica cambiar algunas de las características de algo
            para que esto sea distinto.
          </li>
          <li>
            Confirme que han comprendido el significado de las palabras. Puede,
            por ejemplo, pedir que elaboren oraciones
            nuevas con las palabras aprendidas.
          </li>
          <li>
            Lea la indicación: En la siguiente ilustración, encierra en un
            círculo todo lo que haya sido transformado por el ser humano.
            Explique que en la ilustración hay algunos
            elementos naturales y otros que han sido hechos por las personas.
            Estos últimos son los que tienen que encerrar en un círculo. Déles
            tiempo para trabajar. Pida que señalen todos los
            elementos de la ilustración y luego que señalen cuáles fueron
            encerrados en un círculo. Por ejemplo:
            <ul>
              <li>
                <i>
                  “Los elementos transformados por el ser humano son el corral,
                  hecho para cercar a las vacas; la trocha, construida por las
                  personas a manera de camino; los canales de regadío para
                  obtener agua; y los andenes para aprovechar la tierra”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
